import React from 'react';

const PoliticaDePrivacidade: React.FC = () => {
    return (
        <div className="relative flex min-h-screen w-full flex-col items-center bg-[#f7f9fc] dark:bg-[#101922] font-sans">
            <main className="w-full max-w-4xl flex-1 px-4 sm:px-6 lg:px-8 py-8 md:py-12">
                <div className="rounded-xl border border-gray-200 dark:border-gray-700/50 bg-white dark:bg-background-dark p-6 sm:p-8 shadow-sm">
                    <h1 className="text-[#333333] dark:text-white text-4xl font-black leading-tight tracking-[-0.033em] mb-6">
                        Política de Privacidade
                    </h1>

                    <div className="space-y-6 text-[#666666] dark:text-[#9dabb9]">
                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">1. Introdução</h2>
                            <p className="leading-relaxed">
                                Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais
                                quando você utiliza nossos serviços. Estamos comprometidos em proteger sua privacidade e garantir a segurança
                                de seus dados pessoais.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">2. Informações que Coletamos</h2>
                            <p className="leading-relaxed mb-2">
                                Coletamos as seguintes informações:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li><strong>Informações de Cadastro:</strong> Nome completo, e-mail, CPF, telefone, nome da empresa</li>
                                <li><strong>Informações de Autodesk:</strong> ID Autodesk para integração com ferramentas BIM</li>
                                <li><strong>Informações de Pagamento:</strong> Dados de cobrança processados por nossos parceiros de pagamento</li>
                                <li><strong>Informações de Uso:</strong> Dados sobre como você utiliza nosso serviço, incluindo arquivos carregados e relatórios gerados</li>
                                <li><strong>Informações Técnicas:</strong> Endereço IP, tipo de navegador, sistema operacional, páginas visitadas</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">3. Como Usamos suas Informações</h2>
                            <p className="leading-relaxed mb-2">
                                Utilizamos suas informações para:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Fornecer, operar e manter nossos serviços</li>
                                <li>Processar transações e enviar confirmações relacionadas</li>
                                <li>Melhorar, personalizar e expandir nossos serviços</li>
                                <li>Entender e analisar como você usa nossos serviços</li>
                                <li>Desenvolver novos produtos, serviços e funcionalidades</li>
                                <li>Comunicar-nos com você, seja diretamente ou através de parceiros, para suporte ao cliente, atualizações e informações de marketing</li>
                                <li>Detectar, prevenir e resolver problemas técnicos e de segurança</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">4. Compartilhamento de Informações</h2>
                            <p className="leading-relaxed mb-2">
                                Não vendemos suas informações pessoais. Podemos compartilhar suas informações nas seguintes situações:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li><strong>Prestadores de Serviços:</strong> Com empresas terceirizadas que nos ajudam a operar nosso negócio (processamento de pagamentos, hospedagem, análise)</li>
                                <li><strong>Autodesk:</strong> Para integração com ferramentas BIM, conforme necessário</li>
                                <li><strong>Requisitos Legais:</strong> Quando exigido por lei ou para proteger nossos direitos</li>
                                <li><strong>Transferência de Negócios:</strong> Em caso de fusão, aquisição ou venda de ativos</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">5. Segurança dos Dados</h2>
                            <p className="leading-relaxed">
                                Implementamos medidas de segurança técnicas e organizacionais apropriadas para proteger suas informações pessoais
                                contra acesso não autorizado, alteração, divulgação ou destruição. Isso inclui:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                                <li>Criptografia de dados em trânsito e em repouso</li>
                                <li>Controles de acesso rigorosos</li>
                                <li>Monitoramento contínuo de segurança</li>
                                <li>Auditorias regulares de segurança</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">6. Retenção de Dados</h2>
                            <p className="leading-relaxed">
                                Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir os propósitos descritos nesta
                                Política de Privacidade, a menos que um período de retenção mais longo seja exigido ou permitido por lei.
                                Quando suas informações não forem mais necessárias, nós as excluiremos ou anonimizaremos de forma segura.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">7. Seus Direitos (LGPD)</h2>
                            <p className="leading-relaxed mb-2">
                                De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem os seguintes direitos:
                            </p>
                            <ul className="list-disc list-inside space-y-2 ml-4">
                                <li>Confirmação da existência de tratamento de dados</li>
                                <li>Acesso aos seus dados pessoais</li>
                                <li>Correção de dados incompletos, inexatos ou desatualizados</li>
                                <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos</li>
                                <li>Portabilidade dos dados a outro fornecedor de serviço</li>
                                <li>Eliminação dos dados tratados com seu consentimento</li>
                                <li>Informação sobre compartilhamento de dados</li>
                                <li>Revogação do consentimento</li>
                            </ul>
                            <p className="leading-relaxed mt-2">
                                Para exercer qualquer um desses direitos, entre em contato conosco através dos canais de suporte.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">8. Cookies e Tecnologias Similares</h2>
                            <p className="leading-relaxed">
                                Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o uso do serviço e
                                personalizar conteúdo. Você pode configurar seu navegador para recusar cookies, mas isso pode afetar
                                sua capacidade de usar alguns recursos do serviço.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">9. Privacidade de Menores</h2>
                            <p className="leading-relaxed">
                                Nossos serviços não são destinados a menores de 18 anos. Não coletamos intencionalmente informações
                                pessoais de menores. Se tomarmos conhecimento de que coletamos dados de um menor, tomaremos medidas
                                para excluir essas informações.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">10. Alterações nesta Política</h2>
                            <p className="leading-relaxed">
                                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer
                                alterações publicando a nova Política de Privacidade nesta página e atualizando a data de "última atualização".
                                Recomendamos que você revise esta Política periodicamente.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-[#333333] dark:text-white text-2xl font-bold mb-3">11. Contato</h2>
                            <p className="leading-relaxed">
                                Se você tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados pessoais,
                                entre em contato conosco através dos canais de suporte disponíveis em nossa plataforma.
                            </p>
                        </section>

                        <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
                            <p className="text-sm text-center">
                                Última atualização: {new Date().toLocaleDateString('pt-BR')}
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default PoliticaDePrivacidade;
